/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_How_DescriptionInputs */

const en_seo_how_description = /** @type {(inputs: Seo_How_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Complete Athlete works: find a coach, book a time and train with a plan, reminders and your coach in one app.`)
};

const pl_seo_how_description = /** @type {(inputs: Seo_How_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak działa Complete Athlete: znajdź trenera, zarezerwuj termin i trenuj z planem, przypomnieniami i trenerem w jednej aplikacji.`)
};

/**
* | output |
* | --- |
* | "How Complete Athlete works: find a coach, book a time and train with a plan, reminders and your coach in one app." |
*
* @param {Seo_How_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_how_description = /** @type {((inputs?: Seo_How_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_How_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_how_description(inputs)
	return en_seo_how_description(inputs)
});